import { computed, Injectable, signal } from '@angular/core';
import { SearchRegisteredUser } from '@domains/admin/models/clerk-probate-http.models';
import { getFormattedAutoCompleteOptions } from '../helpers/get-formatted-users-options.helper';

@Injectable()
export class UserSearchStateService {
  private readonly _searchedUsersByEmail = signal<SearchRegisteredUser[]>([]);
  private readonly _searchedUsersByName = signal<SearchRegisteredUser[]>([]);

  private readonly _isLoading = signal(false);

  public readonly searchedUsersByEmail =
    this._searchedUsersByEmail.asReadonly();
  public readonly searchedUsersByName = this._searchedUsersByName.asReadonly();
  public readonly isLoading = this._isLoading.asReadonly();

  public setSearchedUsersByEmail(users: SearchRegisteredUser[]) {
    this._searchedUsersByEmail.set(users);
  }
  public setSearchedUsersByName(users: SearchRegisteredUser[]) {
    this._searchedUsersByName.set(users);
  }

  public setIsLoading(loading: boolean) {
    this._isLoading.set(loading);
  }

  public formattedSearchedUsersByName = computed(() =>
    getFormattedAutoCompleteOptions(this.searchedUsersByName(), 'firstName'),
  );

  public formattedSearchedUsersByEmail = computed(() =>
    getFormattedAutoCompleteOptions(this.searchedUsersByEmail(), 'email'),
  );
}
